import React from 'react';
import PropTypes from 'prop-types';

import TicketLogo from '../../nacre/images/weezticket.svg';
import { ViewPort } from '@weezevent/nacre';

import OrganizationInfos from '../../models/organizationInfos';
import Loading from '../../components/loading';
import EventCreation from './eventCreation';
import { useHistory } from 'react-router-dom';
import { useSegment } from '../../components/tracking/trackingProvider';
import TopBarModules from '../../components/template/topBarModules/topBarModules';
import { allowExitingEventCreation } from './utils';

export default function EventCreationContainer({ organization }) {
    const history = useHistory();
    const { track } = useSegment();
    const [organizationInfos, loading] = OrganizationInfos.useApiModel({
        organizationId: organization.id
    });

    const handleRedirect = React.useCallback(() => {
        if (!allowExitingEventCreation({ organization, organizationInfos })) return;
        track('ACTION > BACK TO HOME LOGO', { 'Page Title': 'CREATE EVENT' });
        history.push(`/ticket/O${organization.pk}`);
    }, [organization, track, history, organizationInfos]);

    if (loading) {
        return <Loading />;
    }

    return (
        <ViewPort
            logo={TicketLogo}
            onClickLogo={handleRedirect}
            topBarModules={<TopBarModules minimal={!allowExitingEventCreation({ organization, organizationInfos })} organization={organization} />}
            displayMenuButton={false}
        >
            <EventCreation organization={organization} organizationInfos={organizationInfos} />
        </ViewPort>
    );
}

EventCreationContainer.propTypes = {
    organization: PropTypes.object.isRequired,
    history: PropTypes.object
};
